import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFadeInOnScroll } from '../../../hooks/useFadeInOnScroll';
import { AnimatedContainer, SectionHeader, EnhancedSectionTitle, SectionSubtitle } from '../../styles/sharedComponents';
import {
  EnterpriseSection,
  EnterpriseGrid,
  EnterpriseContent,
  EnterpriseList,
  EnterpriseItem,
  EnterpriseStats,
  EnterpriseStat,
  EnterpriseStatNumber,
  EnterpriseStatLabel
} from './styles';

const Enterprise: React.FC = () => {
  const { t } = useTranslation();
  const [enterpriseRef, enterpriseVisible] = useFadeInOnScroll<HTMLElement>();

  const benefits = t('enterprise.benefits', { returnObjects: true }) as string[];

  return (
    <EnterpriseSection ref={enterpriseRef} id="enterprise" $isVisible={enterpriseVisible}>
      <AnimatedContainer $isVisible={enterpriseVisible}>
        <SectionHeader>
          <EnhancedSectionTitle>{t('enterprise.title')}</EnhancedSectionTitle>
          <SectionSubtitle>
            {t('enterprise.subtitle')}
          </SectionSubtitle>
        </SectionHeader>

        <EnterpriseGrid>
          <EnterpriseContent>
            <EnterpriseList>
              {benefits.map((benefit, index) => (
                <EnterpriseItem key={index} $isVisible={enterpriseVisible} $delay={100 * (index + 1)}>
                  {benefit}
                </EnterpriseItem>
              ))}
            </EnterpriseList>

            <div style={{ display: 'flex', gap: '16px', marginTop: '32px' }}>
            </div>
          </EnterpriseContent>

          <EnterpriseStats>
            <EnterpriseStat $isVisible={enterpriseVisible} $delay={100}>
              <EnterpriseStatNumber>{t('enterprise.stats.availability.value')}</EnterpriseStatNumber>
              <EnterpriseStatLabel>{t('enterprise.stats.availability.label')}</EnterpriseStatLabel>
            </EnterpriseStat>
            <EnterpriseStat $isVisible={enterpriseVisible} $delay={200}>
              <EnterpriseStatNumber>{t('enterprise.stats.response.value')}</EnterpriseStatNumber>
              <EnterpriseStatLabel>{t('enterprise.stats.response.label')}</EnterpriseStatLabel>
            </EnterpriseStat>
            <EnterpriseStat $isVisible={enterpriseVisible} $delay={300}>
              <EnterpriseStatNumber>{t('enterprise.stats.throughput.value')}</EnterpriseStatNumber>
              <EnterpriseStatLabel>{t('enterprise.stats.throughput.label')}</EnterpriseStatLabel>
            </EnterpriseStat>
            <EnterpriseStat $isVisible={enterpriseVisible} $delay={400}>
              <EnterpriseStatNumber>{t('enterprise.stats.support.value')}</EnterpriseStatNumber>
              <EnterpriseStatLabel>{t('enterprise.stats.support.label')}</EnterpriseStatLabel>
            </EnterpriseStat>
          </EnterpriseStats>
        </EnterpriseGrid>
      </AnimatedContainer>
    </EnterpriseSection>
  );
};

export default Enterprise;
